import { render, staticRenderFns } from "./editors.vue?vue&type=template&id=2e2ab7e7&"
import script from "./editors.vue?vue&type=script&lang=js&"
export * from "./editors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports